import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=cf1f5842&"
import script from "./DocumentApproval.vue?vue&type=script&lang=js&"
export * from "./DocumentApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nix/store/a25r9kpqvyysf8xnakfajmmdkhvc23x1-node_frontend-0.1.0/lib/node_modules/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../nix/store/a25r9kpqvyysf8xnakfajmmdkhvc23x1-node_frontend-0.1.0/lib/node_modules/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDialog,VFlex,VIcon,VProgressCircular,VRadio,VRadioGroup,VRow,VSpacer,VTextField,VTextarea})
